<template>
    <div class="gallery-item">
      <div style="height: 1.6em;" class="row items-end no-wrap">
        <q-icon :name="$utils.contentIcon(item.value.contentType)" />
        <small>{{item.value.contentType.split('/')[1]}}</small>
        <small v-if="item.value.size">({{item.value.size | formatSize}})</small>
      </div>
      <p class="small-label">
        <q-icon name="colorize"/>{{editor}}
      </p>
      <p class="small-label">
        {{item.value.lastEdited | formatTime}}
      </p>
      <div v-if="notReader" class="absolute" style="top: 0;right: 0;background-color: rgba(255, 255, 255, 0.8)">
        <q-btn
            v-if="showEdit"
            @click.stop="goEdit(item)"
            color="primary"
            icon="more_vert"
            dense
            round
            flat
            title="Действия"
        />
      </div>
      <div style="height: 100px" @click="view(item)" class="bg-light row justify-center cursor-pointer">
        <q-icon v-if="item.value.contentType.indexOf('audio') === 0" name="play_arrow" color="faded" size="60px"/>
        <img v-else-if="thumbUrl" :src="thumbUrl">
        <q-icon v-else :name="$utils.contentIcon(item.value.contentType)" color="faded" size="60px"/>
      </div>
      <div
          @click="goToLink"
          :class="{
            'text-secondary': item.value.local && item.value._linkcount,
            'text-primary': !item.value.local && item.value._linkcount,
            'cursor-pointer': item.value._linkcount
          }"
      >
        <q-icon :name="$utils.icon(item.value.link.from)"/>
        <small>{{name}}</small>
      </div>
    </div>
</template>

<script>
import { QIcon } from 'quasar';

export default {
  components: { QIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
    view: {
      type: Function,
      required: true,
    },
    goEdit: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      thumbUrl: '',
      notReader: !this.$store.getters.isReader,
      showEdit: false,
    };
  },
  name: 'galeryitem',
  mounted() {
    if (this.item.value.thumb) {
      this.$store.dispatch('getThumb', this.item.key)
        .then((blob) => {
          this.thumbUrl = URL.createObjectURL(blob);
        })
        .catch((err) => {
          console.log('getThumb error', err);
        });
    }
    this.showEdit = this.item.value.contentType.split('/')[0] === 'image' || this.item.value._linkcount === 0;
  },
  beforeDestroy() {
  },
  computed: {
    name() {
      return this.item.value.link.name || '[В корзине]';
    },
    editor() {
      return this.$store.getters.userScreenName(this.item.value.editedBy);
    },
  },
  methods: {
    goToLink() {
      const l = this.item.value.link.from;
      if (l) {
        const b = l[0] === 'c' ? 'c/all' : 'list';
        this.$router.push(`/${b}/${l}?mid=${this.item.key}`);
      }
    },
  },
};
</script>

<style scoped lang="stylus">
  .gallery-item
    width 150px
    height 190px
    overflow hidden
    position relative
  #a
    transform scale(0.5)
    transform-origin 0 100%
</style>



// WEBPACK FOOTER //
// src/components/galery-item.vue